import React, { useState } from 'react';
import { Panel, PanelEndType } from '../types';

interface PanelEditDialogProps {
  panel: Panel;
  onConfirm: (updated: Panel) => void;
  onCancel: () => void;
}

const sideNames: Record<string, string> = {
  top: '상단 벽', bottom: '하단 벽', left: '좌측 벽', right: '우측 벽'
};

// 패널 종류: [번호, 이름, leftType, rightType]
const PANEL_TYPES: { no: number; label: string; lt: PanelEndType; rt: PanelEndType; desc: string }[] = [
  { no: 1, label: '1번', lt: 'yangsu', rt: 'eumsu', desc: '◁──┤ ├──◁' },
  { no: 2, label: '2번', lt: 'eumsu',  rt: 'eumsu', desc: '▷──┤ ├──◁' },
  { no: 3, label: '3번', lt: 'yangsu', rt: 'yangsu', desc: '◁──┤ ├──▷' },
];

function getPanelTypeNo(lt: PanelEndType, rt: PanelEndType): number {
  if (lt === 'yangsu' && rt === 'eumsu') return 1;
  if (lt === 'eumsu'  && rt === 'eumsu') return 2;
  if (lt === 'yangsu' && rt === 'yangsu') return 3;
  return 0; // 코너 패널 등
}

const PanelEditDialog: React.FC<PanelEditDialogProps> = ({ panel, onConfirm, onCancel }) => {
  const [size, setSize] = useState(panel.size);
  const [leftType, setLeftType] = useState<PanelEndType>(panel.leftType);
  const [rightType, setRightType] = useState<PanelEndType>(panel.rightType);

  const currentTypeNo = getPanelTypeNo(leftType, rightType);
  const isCorner = panel.leftType === 'corner' || panel.rightType === 'corner';

  const handleSelectType = (lt: PanelEndType, rt: PanelEndType) => {
    setLeftType(lt);
    setRightType(rt);
  };

  const handleConfirm = () => {
    if (size < 100) {
      alert('패널 사이즈는 최소 100mm 이상이어야 합니다.');
      return;
    }
    onConfirm({
      ...panel,
      size,
      isCustom: size !== 900,
      leftType,
      rightType,
    });
  };

  return (
    <div style={overlayStyle}>
      <div style={dialogStyle}>
        <h3 style={{ margin: '0 0 18px 0', fontSize: 19, fontWeight: 700, color: '#191F28' }}>
          패널 수정 - {sideNames[panel.wallSide]} #{panel.index + 1}
        </h3>

        <div style={{ marginBottom: 16, padding: 10, background: '#f5f5f5', borderRadius: 6, fontSize: 12, color: '#666' }}>
          현재: {panel.size}mm / {panel.isCustom ? '커스텀' : '표준'}
        </div>

        <div style={fieldStyle}>
          <label style={dlabelStyle}>패널 사이즈 (mm)</label>
          <input type="number" value={size} onChange={e => setSize(Number(e.target.value))}
            style={dinputStyle} min={100} step={10} />
        </div>

        {/* 패널 종류 선택 (코너 패널은 변경 불가) */}
        <div style={fieldStyle}>
          <label style={dlabelStyle}>패널 종류</label>
          {isCorner ? (
            <div style={{ fontSize: 12, color: '#999', padding: '8px 0' }}>코너 패널은 종류 변경 불가</div>
          ) : (
            <div style={{ display: 'flex', gap: 8 }}>
              {PANEL_TYPES.map(pt => (
                <button
                  key={pt.no}
                  onClick={() => handleSelectType(pt.lt, pt.rt)}
                  style={{
                    flex: 1,
                    padding: '8px 6px',
                    border: currentTypeNo === pt.no ? '2px solid #3182F6' : '1px solid #E5E8EB',
                    borderRadius: 6,
                    background: currentTypeNo === pt.no ? '#E8F3FF' : '#fff',
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 3,
                  }}
                >
                  <span style={{ fontSize: 13, fontWeight: 'bold', color: '#333' }}>{pt.label}</span>
                  <span style={{ fontSize: 10, color: '#888', letterSpacing: -0.5 }}>{pt.desc}</span>
                </button>
              ))}
            </div>
          )}
        </div>


        <div style={{ display: 'flex', gap: 8, marginTop: 20, justifyContent: 'flex-end' }}>
          <button onClick={onCancel} style={cancelBtnStyle}>취소</button>
          <button onClick={handleConfirm} style={confirmBtnStyle}>적용</button>
        </div>
      </div>
    </div>
  );
};

const overlayStyle: React.CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.4)', display: 'flex',
  alignItems: 'center', justifyContent: 'center', zIndex: 1000,
};
const dialogStyle: React.CSSProperties = {
  background: '#fff', borderRadius: 24, padding: 24,
  width: 360, boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
};
const fieldStyle: React.CSSProperties = { marginBottom: 12 };
const dlabelStyle: React.CSSProperties = {
  display: 'block', marginBottom: 4, fontSize: 13, fontWeight: 'bold', color: '#555',
};
const dinputStyle: React.CSSProperties = {
  width: '100%', padding: '7px 10px', fontSize: 14,
  border: '1px solid #E5E8EB', borderRadius: 8, boxSizing: 'border-box',
};
const cancelBtnStyle: React.CSSProperties = { height: 38, padding: '0 16px', fontSize: 14, fontWeight: 600, border: 'none', borderRadius: 10, background: '#F2F4F6', color: '#333D4B', cursor: 'pointer' };
const confirmBtnStyle: React.CSSProperties = { height: 38, padding: '0 18px', fontSize: 14, fontWeight: 600, border: 'none', borderRadius: 10, background: '#3182F6', color: '#fff', cursor: 'pointer' };

export default PanelEditDialog;
